import {
  HouseDoor,
  Tag,
  Key,
  KeyFill,
  Search,
  PersonCheck,
  ShieldCheck,
  Instagram,
  Facebook,
  Brush,
  Tools,
  Shop,
  Wrench,
  HeartPulse,
} from "react-bootstrap-icons";

// Data files refer to icons by name so they stay plain, serialisable config.
const ICONS = {
  HouseDoor,
  Tag,
  Key,
  KeyFill,
  Search,
  PersonCheck,
  ShieldCheck,
  Instagram,
  Facebook,
  Brush,
  Tools,
  Shop,
  Wrench,
  HeartPulse,
};

export const getIcon = (name) => ICONS[name] ?? HouseDoor;
